var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass:
        "settings-fieldset-interior-item settings-fieldset-interior-item--timezone"
    },
    [
      _c("TimezoneSelect", {
        attrs: {
          "additional-timezones": _vm.additionalTimezones,
          value: _vm.timezone
        },
        on: { change: _vm.setTimezoneValue }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }